// import React, { useState } from "react";
// import axios from "axios";
// import "./App.css";

// export default function StockAnalyzer() {
//   const [symbol, setSymbol] = useState("");
//   const [data, setData] = useState(null);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const fetchStockData = async () => {
//     if (!symbol) return;
//     setLoading(true);
//     setError(null);
//     setData(null);

//     try {
//       const response = await axios.get(`https://backend-drab-alpha-64.vercel.app/api/stock/${symbol}`);
//       setData(response.data);
//     } catch (err) {
//       setError("Stock data not found. Try a valid symbol.");
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="container">
//       <h1>Stock Performance Analyzer 📈</h1>
//       <div className="input-container">
//         <input 
//           type="text" 
//           placeholder="Enter Stock Symbol (e.g., AAPL)"
//           value={symbol}
//           onChange={(e) => setSymbol(e.target.value.toUpperCase())}
//         />
//         <button onClick={fetchStockData}>Analyze 📊</button>
//       </div>

//       {loading && <p>Fetching stock data...</p>}
//       {error && <p className="error">{error}</p>}
      
//       {data && (
//         <div className="result">
//           <h2>{data.symbol} Analysis</h2>
//           <p><strong>XIRR:</strong> {data.xirr.toFixed(2)}%</p>
//           <p><strong>Sharpe Ratio:</strong> {data.sharpe.toFixed(2)}</p>
//           <p><strong>Volatility:</strong> {data.volatility.toFixed(2)}%</p>
//         </div>
//       )}
//     </div>
//   );
// }






import React, { useState } from "react";
import axios from "axios";
import "./App.css";

function App() {
    const [symbol, setSymbol] = useState("");
    const [data, setData] = useState(null);
    const [error, setError] = useState("");

    const fetchStockData = async () => {
        if (!symbol) return;
        try {
            // Fixed double slash issue
            const response = await axios.get(`https://backend-drab-alpha-64.vercel.app/api/stock/${symbol}`);
            setData(response.data);
            setError("");
        } catch (err) {
            console.error("Error fetching stock data:", err); // Log error to debug
            setError("Stock data not found");
            setData(null);
        }
    };

    return (
        <div className="container">
            <h1>Stock Performance Analyzer</h1>
            <input type="text" placeholder="Enter Stock Symbol" value={symbol} onChange={(e) => setSymbol(e.target.value)} />
            <button onClick={fetchStockData}>Analyze</button>

            {error && <p className="error">{error}</p>}

            {data && (
                <div className="results">
                    <h2>{data.symbol}</h2>
                    <p><strong>XIRR:</strong> {data.xirr}</p>
                    <p><strong>Sharpe Ratio:</strong> {data.sharpe}</p>
                    <p><strong>Volatility:</strong> {data.volatility}</p>
                </div>
            )}
        </div>
    );
}

export default App;
